// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { ProductCategory } from "../../data/commerce/product-category";
import { ProductDocument } from "./documents/product-document";
import { ItemEnvelope } from "./base/item-envelope";

export class ProductEnvelope extends ItemEnvelope {
	public constructor(jsonEnvelope: any) {
		super(jsonEnvelope, "Product");
		if (jsonEnvelope) {
			this.ProductCategoriesPool = jsonEnvelope.ProductCategoriesPool;
			this.Document = jsonEnvelope.Document;
			this.CreatedOnUTC = jsonEnvelope.CreatedOnUTC;
			this.CreateUserUID = jsonEnvelope.CreateUserUID;
			this.ModifiedOnUTC = jsonEnvelope.ModifiedOnUTC;
			this.ModifyUserUID = jsonEnvelope.ModifyUserUID;
		}
	}
	public ProductCategoriesPool: ProductCategory[] = [];
	public override Document: ProductDocument = new ProductDocument();
	public override get ItemId(): number { return this.Document.Item.ProductId; }
	public override get ItemName(): string { return this.Document.Item.Name; }
}